import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { API_HOUSEHOLD_URL } from "constants/config"
import { authBaseQuery } from "../api"

if (!API_HOUSEHOLD_URL) {
  throw new Error("REACT_APP_API_HOUSEHOLD_URL is not defined")
}

export const householdApi = createApi({
  reducerPath: "householdApi",
  baseQuery: authBaseQuery(API_HOUSEHOLD_URL),
  tagTypes: [
    "Attributes",
    "Organizations",
    "Categories",
    "Modalities",
    "SubCategories",
    "SurveysHousehold",
    "SurveyHousehold",
    "FormsByCountryAndSubcategory",
    "BaseXlsForm",
    "XlsForm",
    "BaseSchemas",
    "LinkedSurveys",
    "LinkedForms",
    "XlsFormMappings",
    "XlsFormFieldsWithGroups",
    "XlsFormQuestionList",
    "DiscardedFormFields",
    "XlsFormSchema",
    "BaseXlsHH",
    "FormChoiceList",
    "FormGroupList",
    "CustomQuestions",
    "ChoicesOption",
  ],
  endpoints: () => ({}),
})
